export const PACKAGE_NAME = 'jiraIssueNavigatorSaveResetViewSettingsButton';
export const TEAM_NAME = 'wanjel';
